import React, { useMemo } from 'react';

const RULES = [
  { prefix: '#### ', tag: 'h4', className: 'text-lg font-bold text-gray-900 mt-4 mb-2' },
  { prefix: '### ', tag: 'h3', className: 'text-xl font-bold text-gray-900 mt-6 mb-3' },
  { prefix: '## ', tag: 'h2', className: 'text-2xl font-bold text-gray-900 mt-8 mb-4' },
];

const toBlock = (line, lineNo) => {
  const id = `line-${lineNo}`;
  const rule = RULES.find((r) => line.startsWith(r.prefix));
  if (rule) return { id, tag: rule.tag, className: rule.className, text: line.slice(rule.prefix.length) };
  if (line.trim() === '') return { id, tag: 'br' };
  if (line.trim().startsWith('- ')) {
    return { id, tag: 'li', className: 'text-gray-700 leading-relaxed', text: line.replace(/^\s*-\s*/, '') };
  }
  return { id, tag: 'p', className: 'text-gray-700 leading-relaxed mb-4', text: line };
};

const groupLists = (blocks) => blocks.reduce((acc, block) => {
  const last = acc[acc.length - 1];
  if (block.tag !== 'li') return [...acc, block];
  if (last?.tag === 'ul') {
    last.items.push(block);
    return acc;
  }
  return [...acc, { id: `list-${block.id}`, tag: 'ul', items: [block] }];
}, []);

export const parseContent = (content) => groupLists(content.split('\n').map((line, lineNo) => toBlock(line, lineNo + 1)));

const Inline = ({ text }) => text.split(/(\*\*[^*]+\*\*)/).map((part, i) =>
  part.startsWith('**') && part.endsWith('**')
    ? <strong key={`b-${i}-${part}`} className="font-semibold text-gray-900">{part.slice(2, -2)}</strong>
    : <React.Fragment key={`t-${i}-${part}`}>{part}</React.Fragment>
);

const Block = ({ block }) => {
  const { tag: Tag, className, text, items } = block;
  if (Tag === 'br') return <br />;
  if (Tag === 'ul') {
    return (
      <ul className="list-disc ml-6 mb-4 space-y-1">
        {items.map((item) => <li key={item.id} className={item.className}><Inline text={item.text} /></li>)}
      </ul>
    );
  }
  return <Tag className={className}><Inline text={text} /></Tag>;
};

export const ArticleContent = ({ content }) => {
  const blocks = useMemo(() => parseContent(content), [content]);
  return blocks.map((block) => <Block key={block.id} block={block} />);
};
